<template>
    <div id="listDetail">
        <my-header></my-header>
        <div class="main-container mainCon">
            <div class="detailCon">
                <div >
                    <el-button size="mini" type="primary" style="float: right" @click="join">报名</el-button>
                    <h2 style="text-align: center">“ {{ detailData.announcementName }} ”  招标公告</h2>
                    <!-- <img style="margin-top: 12px;" src="../../assets/images/invitemanage/titbg.png"/> -->
                </div>
                <section class="detailList">
                    <h3>招标概况</h3>
                    <ul class="firstList">
                        <li>
                            <em>招标事项：</em><span>{{ detailData.announcementName }}</span>
                        </li>
                        <li v-if="acType == 1">
                            <em>项目名称：</em><span>{{ detailData.projectName }}</span>
                        </li>
                        <li v-else>
                            <em>区域名称：</em><span>{{ detailData.regionalCompanyNames }}</span>
                        </li>
                        <li>
                            <em>办公地址：</em><span>{{ detailData.officeAddr }}</span>
                        </li>
                        <li>
                            <em>招标类别：</em><span>{{ detailData.categoryName }}</span>
                        </li>
                        <li>
                            <em>计划工期：</em><span>{{ detailData.constructionRequirements }}</span>
                        </li>
                        <li>
                            <em>项目概述及规模：</em><span>{{ detailData.projectOverview }}</span>
                        </li>
                        <li>
                            <em>招标范围/内容：</em><span>{{ detailData.bidRanges }}</span>
                        </li>
                        <li>
                            <em>资质/要求：</em><span>{{ detailData.qualityRequiements }}</span>
                        </li>
                        <li>
                            <em>报名截止时间：</em><span>{{ detailData.applyEndDate }}</span>
                        </li>
                    </ul>
                    <!-- <h3>入围标准</h3>
                    <p>{{ detailData.entryConditions }}</p> -->
                    <h3>联系方式</h3>
                    <p>
                    <span></span>
                        <strong>
                        <div>联系人姓名：{{detailData.contactInfo}}</div>
                        <div>联系人电话：{{detailData.contactPhone}}</div>
                        <div>联系人邮箱：{{detailData.contactEmail}}</div>
                        </strong>
                    </p>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'listDetail',
        data() {
            return {
                messageId: '',
                acType: '',//1,代表单项招标，2,代表集采招标
                detailData: {}//详情信息
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.messageId = this.$route.params.id;
            this.acType = this.$route.params.type;
            let _this = this;
            this.$root.getHttp('v1/sAnnouncement/public/getSAnnouncementById/'+this.messageId,function(res){
//                console.log('detail',res)
                _this.detailData = res.data.data;
            })
        },
        methods:{
            join(){
                if (!this.$root.isLogin){
                    this.$root.$alert("还未登录，请登录后报名!",{
                        type:'warning',
                        callback:action =>  {
                            this.$router.push({
                                name: 'index',
                                params:{url: '/#'+encodeURIComponent(this.$route.fullPath)}
                            });
                        }
                    })
                }else{
                    let that = this
                    this.$root.postHttp('/v1/outerformflowHS/announcementApply',{
                        'announcementId':this.detailData.id,
                        'suppliersId':window.sessionStorage.getItem('loginId')
                    },function (res) {
                        // debugger
                        if (res.data.code == '1'){
                            that.$alert('报名成功',{type:'success'})
                        }
                    })
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #listDetail {
        background-color: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: white !important;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                // background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        & .mainCon {
            margin-top: 15px;
            padding-bottom: 50px;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .detailCon {
            padding: 70px 70px 90px;
            background: #fff;
            .detailList {
                /*margin-top: 20px;*/
                h3 {
                    margin-top: 30px;
                    padding-left: 75px;
                    padding-top: 23px;
                    text-align: left;
                    font-size: 16px;
                    line-height: 26px;
                    background: url('../../assets/images/invitemanage/titbg01.png') no-repeat;
                }
                h3:nth-of-type(2){
                    background: url('../../assets/images/invitemanage/titbg02.png') no-repeat;
                }
                h3:nth-of-type(3){
                    background: url('../../assets/images/invitemanage/titbg03.png') no-repeat;
                }
                .firstList {
                    margin-top: 30px;
                    padding: 0 65px;
                    li {
                        text-align: left;
                        /*margin-top: 20px;*/
                        font-size: 14px;
                        line-height: 48px;
                        em {
                            color: $--text-color-lighter;
                            font-style: normal;
                            padding-left: 25px;
                            background: url('../../assets/images/invitemanage/listIcon.png') no-repeat;
                        }
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
                p {
                    margin-top: 25px;
                    padding: 0 65px;
                    text-align: left;
                    font-size: 14px;
                    line-height: 34px;
                    color: $--text-color-light;
                }
                .email {
                    span {
                        display: inline-block;
                        margin-right: 5px;
                        width: 32px;
                        height: 32px;
                        vertical-align: middle;
                        background: url('../../assets/images/invitemanage/icon06.png') no-repeat;
                    }
                    strong {
                        color: $--text-color;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invite/ListDetail.vue